export enum AvatarPlacement {
  Top = 'top',
  Bottom = 'bottom'
}
